import Quill, { Parchment } from 'quill/core';
import { useQuill } from './QuillContext';
import { MOD_KEY } from '../constants/os';
import useEventListener from '../utils/useEventListener';
import isSelectableInlineEmbed from './utils/isSelectableInlineEmbed';

// eslint-disable-next-line import/no-unused-modules -- expose for testing
export const expandSelectionToWord = (quill: Quill) => {
  const range = quill.getSelection();
  if (!range) return false;
  const [leaf, offset] = quill.getLeaf(range.index);
  if (!(leaf instanceof Parchment.TextBlot)) return false;
  const value = leaf.value();
  let actualOffset = offset;
  if (offset > value.length - 1) {
    actualOffset = value.length - 1;
  } else if (
    /\s/.test(value[offset] ?? '') &&
    !/\s/.test(value[offset - 1] ?? '')
  ) {
    actualOffset = offset - 1;
  }
  const index = range.index + actualOffset - offset;
  const char = value[actualOffset];

  const charRegexes = ['[a-zA-Z]', '[.\\d]'];
  const regex = charRegexes.find((r) => new RegExp(r).test(char ?? ''));
  if (!regex) {
    quill.setSelection(index, 1);
    return true;
  }

  const prefix = value.slice(0, actualOffset).match(new RegExp(`${regex}+$`));
  const suffix = value.slice(actualOffset + 1).match(new RegExp(`^${regex}+`));
  const prefixLength = prefix ? prefix[0].length : 0;
  const suffixLength = suffix ? suffix[0].length : 0;
  quill.setSelection(index - prefixLength, prefixLength + 1 + suffixLength);
  return true;
};

const useLinkShortcut = () => {
  const {
    activeBlot,
    quill,
    selection: { range, formats },
    editingLinkChange,
  } = useQuill();

  useEventListener(quill?.root, 'keydown', (e) => {
    if (!quill) return;
    // Workaround to allow jump to post to bind to mod+k
    if (e.key !== 'k' || !e[MOD_KEY] || !range) return;

    const isInlineBlot = isSelectableInlineEmbed(activeBlot);
    const isTitleFocused = quill.isTitleFocused();
    const lines = quill.getLines(range.index, range.length);
    const isMultiline = lines.length > 1;
    const [blot] = lines;

    if (
      isMultiline ||
      isTitleFocused ||
      isInlineBlot ||
      blot instanceof Parchment.EmbedBlot
    ) {
      return;
    }

    if (formats.link) {
      if (range.length) {
        quill.format('link', false, Quill.sources.USER);
      }
    } else if (range.length || expandSelectionToWord(quill)) {
      editingLinkChange(true);
    }
    e.stopPropagation();
    e.preventDefault();
  });
};

export default useLinkShortcut;
